'use strict';

var customFieldModule = angular.module('t2g.customFields', [
  'gettext',
  'ui.router',
  require('t2g.common.services.modelService').name,
  require('t2g.common.services.notificationService').name,
]);

module.exports = customFieldModule;

customFieldModule.config(function($stateProvider) {
  $stateProvider.state('private.main.customFields', {
    url: '/customFields',
    title: 'Custom Fields',
    templateUrl: '/app/modules/customFields/CustomFieldsView.html?v=4.5.6',
    controller: 'CustomFieldCtrl as CustomFieldCtrl',
    resolve: {
      officeResolve: function(OfficeDA) {
        return OfficeDA.get();
      },
    },
  });
});

/**
 * @param $scope
 * @param officeResolve
 * @param OfficeModel
 * @param Notification
 * @constructor
 */
var CustomFieldCtrl = function($scope, gettextCatalog, Notification, OfficeModel, officeResolve) {
  var self = this;
  this.showPremiumNotification = $scope.subscription.onlyBasicFunctions;
  this.scope_ = $scope;
  this.scope_.office = officeResolve;
  this.scope_.office.settings.customFields = this.scope_.office.settings.customFields || {
    customer: [],
    appointment: [],
  };
  this.scope_.fieldTypes = [];
  this.OfficeModel_ = OfficeModel;
  this.Notification_ = Notification;
  this.gettextCatalog = gettextCatalog;

  $scope.fieldTypes = [
    {
      name: gettextCatalog.getString('Textfield'),
      type: 'textfield',
    },
    {
      name: gettextCatalog.getString('Textarea'),
      type: 'textarea',
    },
    {
      name: gettextCatalog.getString('Select'),
      type: 'select',
    },
    {
      name: gettextCatalog.getString('Radio'),
      type: 'radio',
    },
  ];

  /// Select = Auswahl
  self.optionTranslation_ = gettextCatalog.getString('Select');
};

/**
 * @param {object} field
 */
CustomFieldCtrl.prototype.select = function(field) {
  this.scope_.currentField = field;
};

/**
 * @param {string} type
 */
CustomFieldCtrl.prototype.add = function(type) {
  var self = this;
  var newField = {
    label: self.gettextCatalog.getString('New field'),
    required: true,
    booking: true,
    type: 'textfield',
  };
  self.scope_.office.settings.customFields[type].push(newField);
  self.select(newField);
};

/**
 * delete custom field
 */
CustomFieldCtrl.prototype.delete = function() {
  var self = this;
  var index1 = this.scope_.office.settings.customFields.customer.indexOf(this.scope_.currentField);
  var index2 = this.scope_.office.settings.customFields.appointment.indexOf(
    this.scope_.currentField,
  );

  if (index1 > -1) {
    this.scope_.office.settings.customFields.customer.splice(index1, 1);
  }

  if (index2 > -1) {
    this.scope_.office.settings.customFields.appointment.splice(index2, 1);
  }

  if (index1 > -1 || index2 > -1) {
    this.OfficeModel_.update(this.scope_.office, function(error) {
      if (error) {
        self.Notification_.addErrorMessage(
          self.gettextCatalog.getString('Cant remove custom field (Error: {{error}})', {
            error: error,
          }),
        );
      } else {
        self.Notification_.addSuccessMessage(self.gettextCatalog.getString('Custom field removed'));
      }
    });
    this.scope_.currentField = null;
  }
};

/**
 * fired if field type selectbox has changed
 */
CustomFieldCtrl.prototype.changeTypeHandler = function() {
  var multiOptionFields = {
    radio: true,
    select: true,
  };

  if (multiOptionFields[this.scope_.currentField.type]) {
    this.scope_.currentField.options = this.scope_.currentField.options || [];

    if (this.scope_.currentField.options.length === 0) {
      this.scope_.currentField.options.push({
        label: this.optionTranslation_ + ' 1',
      });

      this.scope_.currentField.options.push({
        label: this.optionTranslation_ + ' 2',
      });
    }
  } else {
    this.scope_.currentField.options = null;
  }
};

/**
 * @param {object} option
 */
CustomFieldCtrl.prototype.removeOption = function(option) {
  var index = this.scope_.currentField.options.indexOf(option);

  if (this.scope_.currentField.options.length > 2) {
    this.scope_.currentField.options.splice(index, 1);
  }
};

/**
 * add an option to radio option list
 */
CustomFieldCtrl.prototype.addOption = function() {
  this.scope_.currentField.options.push({
    label: this.optionTranslation_,
  });
};

/**
 * save custom fields
 */
CustomFieldCtrl.prototype.save = function() {
  var self = this;

  this.OfficeModel_.update(this.scope_.office, function(error) {
    if (error) {
      self.Notification_.addErrorMessage(
        self.gettextCatalog.getString('Cant save custom field (Error: {{error}})', {
          error: error,
        }),
      );
    } else {
      self.Notification_.addSuccessMessage(self.gettextCatalog.getString('Custom field saved'));
    }
  });
};

CustomFieldCtrl.prototype.moveField = function(index, type, direction) {
  if (direction > 0) {
    if (index > 0) {
      this.scope_.office.settings.customFields[type].move(index, index - 1);
    }
  } else {
    if (index < this.scope_.office.settings.customFields[type].length - 1) {
      this.scope_.office.settings.customFields[type].move(index, index + 1);
    }
  }
  this.save();
};

/**
 * back to custom field list
 */
CustomFieldCtrl.prototype.back = function() {
  this.scope_.currentField = null;
};

customFieldModule.controller('CustomFieldCtrl', CustomFieldCtrl);



// WEBPACK FOOTER //
// ./src/app/modules/customFields/customFieldsModule.js